export const state = {
  admins: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  applications: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  campaigns: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "campaign_status_id",
    sortDesc: false,
    totalRows: 1,
    isFetched: false,
  },
  notifications: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  leagues: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    application: {},
  },
  league_rewards: {
    league: {},
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  league_data: {
    league: {},
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  register_codes: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    application: null,
    isFetched: false,
  },
  application_data: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    application: {},
    isFetched: false,
  },
  wallet: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    application: {},
    isFetched: false,
  },
  tickets: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    department: {},
    section: {},
    status: {},
    isFetched: false,
  },
  developers: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  bankAccounts: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
  },
  transferRequests: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
  application_log: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    application: {},
    isFetched: false,
  },
  mobile_brand: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
  net_provider: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
  operator: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
  location: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
  android_api_level: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: "",
    sortBy: "id",
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
};

export const mutations = {
  UPDATE_TABLE_DETAIL(state, payload) {
    state[payload.key] = payload.table;
  },
  ADD_NEW_ITEM(state, payload) {
    state[payload.key].data.unshift(payload.item);
    state[payload.key].totalRows++;
  },
  UPDATE_ITEM(state, payload) {
    let item = state[payload.key].data.find((o) => o.id === payload.item.id);
    state[payload.key].data[state[payload.key].data.indexOf(item)] =
      payload.item;
  },
  UPDATE_PARAM(state, { tableName, key, value }) {
    state[tableName][key] = value;
  },
};

export const actions = {
  updateTableDetail({ commit }, payload) {
    commit("UPDATE_TABLE_DETAIL", payload);
  },
  addNewItem({ commit }, payload) {
    commit("ADD_NEW_ITEM", payload);
  },
  updateItem({ commit }, payload) {
    commit("UPDATE_ITEM", payload);
  },
};
